import { DotsVertical } from "@untitled-ui/icons-react";
import classNames from "classnames";

export default function DotButton({ className }: { className?: string }) {
  return (
    <div
      className={classNames(
        "flex cursor-pointer items-center justify-center",
        className,
      )}
    >
      <DotsVertical className="size-5 text-gray-400 hover:text-gray-600" />
    </div>
  );
}
